import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert,Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { postDataLogin } from '../ApiServices/ApiService';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; 
import LoginNav from './LoginNav';
import FooterPage from './FooterPage';
import About from './../assets/icons/aboutus.png';

const AboutUsPage = () => {
  const navigate = useNavigate();
  const imageStyle={
    width: '100%',
    maxWidth: '350px',
    height: '350px',
    display: 'block',
    marginRight: 'auto',
    marginLeft: 'auto',
    borderRadius: '20px'
  }
  


  return (
    <>
    <LoginNav></LoginNav>
    <div className="background-container" style={{overflowX:'hidden',marginBottom:'15px'}}>
      <div>
      <h2 className='login-heading' style={{marginBottom:'50px'}}>About Us</h2>
      </div>
      
      <div style={{marginBottom:'5px',marginLeft:'30px'}} className='row'>
      <div className='col-md-6' >
      <p className='about-para' style={{marginLeft:'50px'}}>
      Your BUDDY, your go-to destination for cutting-edge F&B order management systems. At Your BUDDY, we are passionate about helping businesses in the food industry ease the pain points associated with managing and delivering orders.</p>
      <p className='about-para' style={{marginLeft:'50px'}}>  Our user-friendly and intuitive software streamlines the ordering and delivery process, allowing customers to place their orders with ease and businesses to efficiently manage their operations. Our focus on customer satisfaction means that we are constantly working to improve our system and provide the best possible experience for both businesses and their customers.</p>
      </div>
      <div className='col-md-6 ' style={{marginBottom:'5px'}}>
      <img src={About} style={imageStyle}/>
      </div>
      </div>
      <div className='col-md-11' style={{marginBottom:'5px',marginLeft:'30px'}}>
        <p className='about-para' style={{marginLeft:'50px'}}>
            We understand that the F&B industry is fast-paced and constantly evolving, and that's why we are committed to staying ahead of the curve with innovative solutions that make a real difference. Whether you're a small cafe or a large restaurant chain, our software is designed to meet the unique needs of your business and help you succeed.
        </p>

      </div>
      </div>
      
      <FooterPage></FooterPage>
    </>
     
  );
};

export default AboutUsPage